import { render, staticRenderFns } from "./AssignUsersModal.vue?vue&type=template&id=479ba789&scoped=true"
import script from "./AssignUsersModal.vue?vue&type=script&lang=js"
export * from "./AssignUsersModal.vue?vue&type=script&lang=js"
import style0 from "./AssignUsersModal.vue?vue&type=style&index=0&id=479ba789&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479ba789",
  null
  
)

export default component.exports